import Cropper from 'cropperjs';

angular.module('TetherApp').controller('SweepstakesAnalyzeUploadController', [function () {
    this.questions = [];
    this.questionFieldRows = {};

    function handleAnalyzeImageScroll() {
        const toolbar = document.querySelector('#toolbar');
        const analysisToolbar = document.querySelector('#analysis_toolbar');
        let toolbarsHeight = toolbar.clientHeight + analysisToolbar.clientHeight;
        let questionContainer = document.querySelector('#question_container');
        let imageContainer = document.querySelector('#image_container');
        let imageContainerHeight = imageContainer.clientHeight;
        // if viewport is smaller than image, use the viewport height
        imageContainerHeight = window.innerHeight < imageContainerHeight ? window.innerHeight : imageContainerHeight;
        let imageContainerYPosition = window.pageYOffset + imageContainerHeight - toolbarsHeight - 15;
        // 15 is the scroll_inner_container container padding

        if (window.pageYOffset > toolbarsHeight) {
            let topOffset = (imageContainerYPosition <= questionContainer.clientHeight) ?
                '10px' :
                (questionContainer.clientHeight - imageContainerYPosition - 10) + 'px';
            // 10 is just extra padding on the bottom
            imageContainer.style.position = 'fixed';
            imageContainer.style.top = topOffset;
        } else if (window.pageYOffset <= toolbarsHeight) {
            imageContainer.style.position = 'relative';
            imageContainer.style.top = 0;
        }
    }

    this.rotate = function (direction) {
        let rotation = direction === 'left' ? -90 : 90;
        this.cropperImage.rotate(rotation);
    };

    this.setupQuestions = function (questions) {
        this.questions = questions;
        if (questions) {
            questions.forEach(function (question, index) {
                if (question.type === 'details') {
                    this.questionFieldRows[index] = [question.configuration];
                }
            }, this);
        }
        let imageContainer = document.querySelector('#uploaded_image');
        if (imageContainer.localName === 'img' || imageContainer.nodeName === 'IMG') {
            this.cropperImage = new Cropper(imageContainer, {
                viewMode: 0,
                dragMode: 'move',
                autoCrop: false,
                modal: false,
                guides: false,
                highlight: false
            });
        }

        imageContainer.addEventListener('ready', function () {
            angular.element(window).bind('scroll', handleAnalyzeImageScroll);
        });
    };

    this.getQuestionFieldRows = function (index) {
        return this.questionFieldRows[index];
    };

    this.addFieldRow = function (index) {
        this.questionFieldRows[index].push(this.questions[index].configuration);
    };
}]);
